import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(event) {
    const url = new URL(window.location)
    url.searchParams.set("per_page", event.target.value)
    url.searchParams.delete("page")
    window.location = url.toString()
  }

  submit() {
    this.element.closest("form").requestSubmit()
  }
}
